import {useLocation, useParams} from "react-router"
import moment from "moment"

export const TESTING_YEAR_BEGIN = moment().subtract(1, 'year').month(7).date(1)

export interface ReportUrlFilters {
    /** Group id of the report user */
    groupId: number,
    /** Product id of the report type */
    productId: number,
    /** Creation date for any Take in the report */
    startDate: moment.Moment,
    /** End date for a Take that has fully finishes a test */
    endDate: moment.Moment,
    /** View only takes that have had activity within the last hour */
    recentActivity: boolean,
    /** Modifies beginStartDateRange behavior *
     *  TODO - investigate how */
    assessmentStart: boolean,
}

/** ReportParams are not stable, as many report pages differ in the params they use, but these are common. */
type ReportParams = {
    groupId?: string
    productId?: string
}

/** There are several parameters that we often store in the report url.
 *  This makes them easily available as a hook */
export function useReportUrlFilters(): ReportUrlFilters {
    const {groupId, productId} = useParams<ReportParams>()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    return {
        groupId: Number(groupId),
        productId: productId ? Number(productId) : Number(searchParams.get("productId")),
        startDate: moment(searchParams.get("startDate")) ?? TESTING_YEAR_BEGIN,
        endDate: moment(searchParams.get("endDate")) ?? moment(),
        assessmentStart: searchParams.get("assessmentStart") === "true",
        recentActivity: searchParams.get("recentActivity") === "true",
    }
}
